export function collectClauses(): HTMLElement[] {
  return Array.from(document.querySelectorAll('[data-nav-tab]'));
}
